module.exports = "pegasus/assets/themelp1/travel/105.png";